"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const UI_1 = require("~/components/UI");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const react_helmet_async_1 = require("react-helmet-async");
const EditCustomerModal_module_scss_1 = __importDefault(require("./EditCustomerModal.module.scss"));
const DiscountsController_1 = __importDefault(require("../AddCustomerModal/DiscountsController"));
const CustomerInfo_1 = __importDefault(require("./CustomerInfo/CustomerInfo"));
function EditCustomerModal() {
    const { t } = (0, react_i18next_1.useTranslation)(['customer']);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const customerId = Number((0, react_router_dom_1.useParams)().customerId);
    const { dispatchGetCustomer, dispatchUpdateCustomer, dispatchSetCustomerRequestSuccess, dispatchSetExistingCustomerInfo, } = (0, redux_1.bindActionCreators)({
        dispatchGetCustomer: actions_1.getCustomer,
        dispatchUpdateCustomer: actions_1.updateCustomer,
        dispatchSetExistingCustomerInfo: actions_1.setCustomerData,
        dispatchSetCustomerRequestSuccess: actions_1.setCustomerRequestSuccess,
    }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        dispatchGetCustomer(customerId);
    }, []);
    const customerInfo = (0, react_redux_1.useSelector)(selectors_1.selectExistingCustomerInfo);
    const [areAllDiscountsValid, setAreAllDiscountsValid] = (0, react_1.useState)(true);
    const [discounts, setDiscounts] = (0, react_1.useState)(customerInfo ? customerInfo.discounts : []);
    const [customer, setCustomer] = (0, react_1.useState)(customerInfo);
    (0, react_1.useEffect)(() => {
        setDiscounts(customerInfo ? customerInfo.discounts : []);
        setCustomer(customerInfo);
    }, [customerInfo]);
    const closeCustomerEditing = () => {
        navigate(-1);
        dispatchSetExistingCustomerInfo(null);
        dispatchSetCustomerRequestSuccess(false);
    };
    const isRequestSuccessed = (0, react_redux_1.useSelector)(selectors_1.selectIsCustomerRequestSuccessed);
    const saveCustomer = (event) => {
        event.preventDefault();
        const customerData = {
            id: customerId,
            discounts,
        };
        dispatchUpdateCustomer(customerData);
    };
    (0, react_1.useEffect)(() => {
        if (isRequestSuccessed) {
            closeCustomerEditing();
        }
    }, [isRequestSuccessed]);
    return customer ? (react_1.default.createElement(UI_1.ContentListModal, { headlineContent: react_1.default.createElement("div", { className: EditCustomerModal_module_scss_1.default.header },
            react_1.default.createElement(react_helmet_async_1.Helmet, null,
                react_1.default.createElement("title", null, "Edit Customer\u2018s Discounts | TBUILD")),
            react_1.default.createElement("div", { className: EditCustomerModal_module_scss_1.default.title }, t('edit-customer')),
            react_1.default.createElement("div", { className: EditCustomerModal_module_scss_1.default.controls },
                react_1.default.createElement(UI_1.Button, { variant: "default", onClick: closeCustomerEditing }, t('actions.cancel')),
                react_1.default.createElement(UI_1.Button, { variant: "primary", disabled: !areAllDiscountsValid, onClick: saveCustomer }, t('actions.save')))), mainContent: react_1.default.createElement("div", { className: EditCustomerModal_module_scss_1.default.content },
            react_1.default.createElement(CustomerInfo_1.default, { customer: customer }),
            react_1.default.createElement(DiscountsController_1.default, { discountsArr: discounts, onValidStateChange: setAreAllDiscountsValid, onDiscountsChange: setDiscounts })) })) : null;
}
exports.default = EditCustomerModal;
